<template>
  <div class="row h-100 no-gutters">
    <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
      <div class="card">
        <div class="card-body">
          <h1 style="text-align: center">
            <img
              id="main-logo"
              class="d-inline-block align-top mr-1"
              style="max-width: 150px;"
              src="@/assets/images/headwear.jpg"
              alt="" />
          </h1>

          <h3 class="text-center mb-4">
            {{ $t('register.title') }}
          </h3>

          <d-alert
            v-if="registerError"
            theme="danger"
            show>
            {{ $t('register.registerError') }}
            <div
              v-if="errors.indexOf('name') > -1"
              v-text="'- ' + errorMessages['name']"></div>
            <div
              v-if="errors.indexOf('email') > -1"
              v-text="'- ' + errorMessages['email']"></div>
            <div
              v-if="errors.indexOf('customer_tax_number') > -1"
              v-text="'- ' + errorMessages['customer_tax_number']"></div>
            <div
              v-if="errors.indexOf('password') > -1"
              v-text="'- ' + errorMessages['password']"></div>
            <div
              v-if="errors.indexOf('password_confirmation') > -1"
              v-text="'- ' + errorMessages['password_confirmation']"></div>
          </d-alert>

          <d-alert
            v-if="registerSuccess"
            theme="success"
            show>
            {{ $t('register.registerSuccess') }}
          </d-alert>

          <form
            v-if="!registerSuccess"
            @submit="register">
            <div class="form-group">
              <label>{{ $t('ui.name') }}</label>
              <d-input
                v-model="name"
                name="name"
                type="text"
                @input="clearError('name')"
                :class="{'is-invalid' : errors.indexOf('name') > -1}" />
            </div>
            <div class="form-group">
              <label>{{ $t('ui.emailAddress') }}</label>
              <d-input
                v-model="email"
                name="email"
                type="email"
                @input="clearError('email')"
                :class="{'is-invalid': errors.indexOf('email') > -1}" />
            </div>
            <div class="form-group">
              <label>{{ $t('register.customerTaxNumber') }}</label>
              <d-input
                v-model="customer_tax_number"
                name="customer_tax_number"
                type="text"
                @input="clearError('customer_tax_number')"
                :class="{'is-invalid' : errors.indexOf('customer_tax_number') > -1}" />
            </div>
            <div class="form-group">
              <label>{{ $t('register.password') }}</label>
              <d-input
                v-model="password"
                name="password"
                type="password"
                autocomplete="off"
                @input="clearError('password')"
                :class="{'is-invalid' : errors.indexOf('password') > -1}" />
            </div>
            <div class="form-group">
              <label>{{ $t('register.passwordConfirmation') }}</label>
              <d-input
                v-model="password_confirmation"
                name="password_confirmation"
                type="password"
                autocomplete="off"
                @input="clearError('password_confirmation')"
                :class="{'is-invalid' : errors.indexOf('password_confirmation') > -1}" />
            </div>
            <button
              type="submit"
              class="btn btn-pill btn-accent d-table mx-auto"
              @click.prevent="register"
              :disabled="submitting">
              <template v-if="!submitting">{{ $t('register.registerLabel') }}</template>
              <template v-else>{{ $t('register.registerInProgress') }}</template>
            </button>
          </form>
        </div>

        <div
          class="card-footer text-center"
          style="background: rgba(90, 97, 105, .06);">
          <a href="/logowanie">
            {{ $t('register.login') }}
          </a>
        </div>
      </div>

      <lang-switcher />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import LangSwitcher from '../components/common/LangSwitcher.vue';

export default {
  name: 'Register',
  components: {
    'lang-switcher': LangSwitcher
  },
  data () {
    return {
      registerError: false,
      registerSuccess: false,
      submitting: false,
      name: '',
      email: '',
      customer_tax_number: '',
      password: '',
      password_confirmation: '',
      errors: [],
      errorMessages: {}
    }
  },
  methods: {
    clearError (errorName) {
      this.errors = this.errors.filter(error => error !== errorName);
    },
    clearErrors () {
      this.registerError = false;
      Vue.set(this, 'errors', []);
      Vue.set(this, 'errorMessages', {});
    },
    register () {
      this.clearErrors();
      this.submitting = true;
      this.$http.post('/customer-panel/auth/register?lang=' + this.$i18n.locale, {
        name: this.name,
        email: this.email,
        customer_tax_number: this.customer_tax_number,
        password: this.password,
        password_confirmation: this.password_confirmation
      }).then((response) => {
        this.submitting = false;

        if (
          response.data &&
          response.data.success
        ) {
          this.registerSuccess = true;
        } else {
          this.registerError = true;
        }
      }).catch((error) => {
        console.log(error);
        this.submitting = false;
        this.registerError = true;

        if (error.response && error.response.data && error.response.data.errors) {
          Vue.set(this, 'errors', Object.keys(error.response.data.errors));

          for (let i = 0; i < this.errors.length; i++) {
            this.errorMessages[this.errors[i]] = error.response.data.errors[this.errors[i]].join(' ');
          }
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
